import { customerApi } from "../../utils/apiConfig";

const getAuthHeaders = () => {
  const token = sessionStorage.getItem("token");

  return {
    Authorization: token ? `Bearer ${token}` : "",
    "Content-Type": "application/json",
  };
};

const getMultipartAuthHeaders = () => {
  const token = sessionStorage.getItem("token");

  return {
    Authorization: token ? `Bearer ${token}` : "",
    "Content-Type": "multipart/form-data",
  };
};

export const downloadDiibExcelFile = (fileName) => {
  return customerApi.get(`/downloadDiibExcelFile/${encodeURIComponent(fileName)}`, {
    headers: getAuthHeaders(),
    responseType: "blob",
  });
};

export const uploadDiibImportExportGroupMappingExcel = (file, options = {}) => {
  const formData = new FormData();

  formData.append("diibMappingExcel", file);

  if (options && Object.keys(options).length > 0) {
    formData.append("options", JSON.stringify(options));
  }

  return customerApi.post("/uploadDiibImportExportGroupMappingExcel", formData, {
    headers: getMultipartAuthHeaders(),
  });
};

export const getDiibImportExportGroupList = (payload = {}) => {
  return customerApi.post("/getDiibImportExportGroupList", payload, {
    headers: getAuthHeaders(),
  });
};

export const getDiibImportExportGroupDetail = (payload) => {
  return customerApi.post("/getDiibImportExportGroupDetail", payload, {
    headers: getAuthHeaders(),
  });
};

export const updateDiibImportExportGroup = (payload) => {
  return customerApi.post("/updateDiibImportExportGroup", payload, {
    headers: getAuthHeaders(),
  });
};

export const deleteDiibImportExportGroup = (payload) => {
  return customerApi.post("/deleteDiibImportExportGroup", payload, {
    headers: getAuthHeaders(),
  });
};

export const toggleDiibImportExportGroupStatus = (payload) => {
  return customerApi.post("/toggleDiibImportExportGroupStatus", payload, {
    headers: getAuthHeaders(),
  });
};

export const uploadDiibTemporarySalesAndTcgbExcel = ({
  salesExcel,
  tcgbExcel,
  diibNo = "",
  options = {},
}) => {
  const formData = new FormData();

  formData.append("salesExcel", salesExcel);
  formData.append("tcgbExcel", tcgbExcel);

  if (diibNo) {
    formData.append("diibNo", diibNo);
  }

  if (options && Object.keys(options).length > 0) {
    formData.append("options", JSON.stringify(options));
  }

  return customerApi.post("/uploadDiibTemporarySalesAndTcgbExcel", formData, {
    headers: getMultipartAuthHeaders(),
  });
};
